import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './loader.module.scss';

const Loader = ({ position = 'fixed', component }) => {
  const hasComponentCssClass =
    component?.getLoaderCssClass &&
    typeof component.getLoaderCssClass === 'function';

  const loaderPosition = hasComponentCssClass ? 'absolute' : position;

  return (
    <div className={hasComponentCssClass && component.getLoaderCssClass()}>
      <div className={classnames(styles.root, styles[loaderPosition])} />
    </div>
  );
};

Loader.propTypes = {
  position: PropTypes.oneOf(['fixed', 'absolute']),
};

export default Loader;
